import { render, staticRenderFns } from "./verticals-list.component.html?vue&type=template&id=1ec90d7a&scoped=true&external"
import script from "./verticals-list.component.vue?vue&type=script&lang=ts"
export * from "./verticals-list.component.vue?vue&type=script&lang=ts"
import style0 from "./verticals-list.component.css?vue&type=style&index=0&id=1ec90d7a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec90d7a",
  null
  
)

export default component.exports